(function () {
  function formatEurosFromCents(amountInCents) {
    var euros = (Number(amountInCents) || 0) / 100;
    var fixed = euros.toFixed(2);
    return fixed.replace('.', ',') + '€';
  }

  function getBubble(marker) {
    if (!marker) return null;
    return marker.querySelector('.cxm-fsb-bubble') || marker.firstElementChild;
  }

  function resetMarkerStates(brushMarker, shipMarker, giftMarker) {
    [brushMarker, shipMarker, giftMarker].forEach(function (marker) {
      if (!marker) return;
      marker.classList.remove('cxm-fsb-unlocked');
      var bubble = getBubble(marker);
      if (!bubble) return;
      bubble.classList.remove('cxm-fsb-pulse');
    });
  }

  function triggerPulse(marker) {
    if (!marker) return;
    var bubble = getBubble(marker);
    if (!bubble) return;

    bubble.classList.remove('cxm-fsb-pulse');
    void bubble.offsetWidth;
    bubble.classList.add('cxm-fsb-pulse');

    setTimeout(function () {
      bubble.classList.remove('cxm-fsb-pulse');
    }, 700);
  }

  function setUnlocked(marker) {
    if (!marker) return;
    marker.classList.add('cxm-fsb-unlocked');
  }

  function updateFreeShippingBar() {
    var rulesEl = document.getElementById('cxm-gift-rules-data');
    var bars = document.querySelectorAll('.cxm-fsb');

    if (!rulesEl || !bars.length) return;

    var validSubtotal = Number(rulesEl.dataset.validSubtotal || 0);
    var brushThreshold = Number(rulesEl.dataset.threshold1 || 3500);
    var shippingThreshold = Number(rulesEl.dataset.threshold2 || 5500);
    var giftThreshold = Number(rulesEl.dataset.threshold3 || 8500);

    bars.forEach(function (bar) {
      var textEl = bar.querySelector('[data-fsb-text]') || bar.querySelector('.cxm-fsb-message');
      var fill = bar.querySelector('.cxm-fsb-fill');
      if (!textEl || !fill) return;

      var brushMarker = bar.querySelector('[data-fsb-marker="brush"]');
      var shipMarker = bar.querySelector('[data-fsb-marker="ship"]');
      var giftMarker = bar.querySelector('[data-fsb-marker="gift"]');

      var previousState = bar.dataset.cxmFsbState || '';

      resetMarkerStates(brushMarker, shipMarker, giftMarker);

      var progress = 0;
      var nextState = 'default';

      if (validSubtotal < brushThreshold) {
        progress = brushThreshold > 0 ? (validSubtotal / brushThreshold) * 0.333333 : 0;

        var remainingBrush = brushThreshold - validSubtotal;

        textEl.innerHTML =
          '🎁 Te faltan solo <span class="cxm-fsb-blue">' +
          formatEurosFromCents(remainingBrush) +
          '</span> para llevarte el <strong>cepillo de esqueleto</strong> <span class="cxm-fsb-blue">(valor 5,90€)</span> GRATIS';
      } else if (validSubtotal < shippingThreshold) {
        progress =
          0.333333 +
          ((validSubtotal - brushThreshold) / (shippingThreshold - brushThreshold)) * 0.333333;
        nextState = 'brush';

        setUnlocked(brushMarker);

        var remainingShip = shippingThreshold - validSubtotal;

        textEl.innerHTML =
          '🎁 Ya tienes el <strong>cepillo de esqueleto gratis</strong> <span class="cxm-fsb-blue">(valor 5,90€)</span>. Te faltan solo <span class="cxm-fsb-blue">' +
          formatEurosFromCents(remainingShip) +
          '</span> para conseguir <strong>ENVÍO GRATIS</strong>';
      } else if (validSubtotal < giftThreshold) {
        progress =
          0.666666 +
          ((validSubtotal - shippingThreshold) / (giftThreshold - shippingThreshold)) * 0.333334;
        nextState = 'shipping';

        setUnlocked(brushMarker);
        setUnlocked(shipMarker);

        var remainingGift = giftThreshold - validSubtotal;

        textEl.innerHTML =
          '🚚 Ya tienes <strong>cepillo</strong> y <strong>envío GRATIS</strong>. Te faltan solo <span class="cxm-fsb-blue">' +
          formatEurosFromCents(remainingGift) +
          '</span> para llevarte el <strong>neceser premium</strong> <span class="cxm-fsb-blue">(valor real 15€)</span> GRATIS';
      } else {
        progress = 1;
        nextState = 'gift';

        setUnlocked(brushMarker);
        setUnlocked(shipMarker);
        setUnlocked(giftMarker);

        textEl.innerHTML =
          '🎉 <strong>¡Neceser premium desbloqueado!</strong> Ya tienes tus regalos <span class="cxm-fsb-blue">(valor real total 20,90€)</span> incluidos en el pedido.';
      }

      progress = Math.max(0, Math.min(1, progress));
      fill.style.width = (progress * 100) + '%';

      if (previousState !== nextState) {
        if (nextState === 'brush') {
          triggerPulse(brushMarker);
        } else if (nextState === 'shipping') {
          triggerPulse(shipMarker);
        } else if (nextState === 'gift') {
          triggerPulse(giftMarker);
        }
      }

      bar.dataset.cxmFsbState = nextState;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(updateFreeShippingBar, 50);
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest('form[action*="/cart"]')) {
      setTimeout(updateFreeShippingBar, 300);
      setTimeout(updateFreeShippingBar, 700);
    }
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.m-quantity__button') ||
      e.target.closest('[data-cxm-add-to-cart]') ||
      e.target.closest('.m-cart-item__remove') ||
      e.target.closest('m-cart-remove-button')
    ) {
      setTimeout(updateFreeShippingBar, 300);
      setTimeout(updateFreeShippingBar, 700);
    }
  });

  ['cart:refresh', 'cart:updated', 'ajaxCart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(updateFreeShippingBar, 100);
      setTimeout(updateFreeShippingBar, 500);
    });
  });
})();